var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 8.167h-28c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h28c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5zm1.5 7.833c0-.828-.672-1.5-1.5-1.5h-28c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h28c.828 0 1.5-.672 1.5-1.5zm0 9.333c0-.828-.672-1.5-1.5-1.5h-28c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h28c.828 0 1.5-.672 1.5-1.5z"
  })));
};
export default SvgNavigation;